'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Link = exports.LinkContentWrapper = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Icons = require('./Icons');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/** @prettier */
var LinkContentWrapper = exports.LinkContentWrapper = function LinkContentWrapper(_ref) {
  var icon = _ref.icon,
      label = _ref.label;

  var finalIcon = icon ? icon : _react2.default.createElement('div', { className: 'placeholder-icon' });

  return _react2.default.createElement(
    'div',
    { className: 'sidenav-link-content-wrapper' },
    _react2.default.createElement(
      _Icons.SideNavSvgIcon,
      null,
      finalIcon
    ),
    _react2.default.createElement(
      'div',
      { className: 'sidenav-link-label sidenav-container-label' },
      label
    )
  );
};

var Link = exports.Link = function Link(_ref2) {
  var hoverText = _ref2.hoverText,
      children = _ref2.children;

  return _react2.default.createElement(
    'li',
    { className: 'sidenav-entry sidenav-link', title: hoverText },
    children
  );
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cjdev/visual-stack/lib/components/SideNav/Link.js
// module id = 306
// module chunks = 0